import axiosInstance from "../helpers/axiosInstance";

export const fetchLostLocations = async (warehouseId) => {
    const res = await axiosInstance.get(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouseId}/lost-locations`
    )
    return res.data
}

export const fetchLostLocationStockSummary = async (warehouseId, locationId) => {
    const res = await axiosInstance.get(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouseId}/lost-locations/${locationId}/stock-summary`
    )
    return res.data
}

export const deleteLostStock = async (data) => {
    const res = await axiosInstance.delete(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/stock-units/delete-lost`,
        { data }
    )
    return res.data
}

export const deleteLostStockByStore = async (data) => {
    const res = await axiosInstance.delete(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/stock-units/delete-lost-by-store`,
        { data }
    )
    return res.data
}

export const fetchDeletedLostHistory = async (params = {}) => {
    const { warehouse_id, ...queryParams } = params
    const res = await axiosInstance.get(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouse_id}/deleted-lost-history`,
        { params: queryParams }
    )
    return res.data
}

